"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var PropTypes = require("prop-types");
var localizers_1 = require("../util/localizers");
var _1 = require("../util/_");
var getFormat = function (props) { return localizers_1.number.getFormat('default', props.format); };
var NumberInput = /** @class */ (function (_super) {
    __extends(NumberInput, _super);
    function NumberInput(props) {
        var _this = _super.call(this, props) || this;
        _this.getDefaultState = function (props) {
            if (props === void 0) { props = _this.props; }
            var value = props.value;
            var decimal = localizers_1.number.decimalChar(null, props.culture);
            var format = getFormat(props);
            var stringValue;
            if (value == null || isNaN(value)) {
                stringValue = '';
            }
            else if (props.editing) {
                stringValue = ('' + value).replace('.', decimal);
            }
            else {
                stringValue = localizers_1.number.format(value, format, props.culture);
            }
            return {
                stringValue: stringValue
            };
        };
        _this._change = function (e) {
            var val = e.target.value;
            var numValue = _this._parse(e.target.value);
            var isIntermediate = _this.isIntermediateValue(numValue, val);
            if (val == null || val.trim() === '') {
                _this.current('');
                _this.props.onChange(undefined);
            }
            if (!isIntermediate) {
                if (numValue !== _this.props.value) {
                    _this.props.onChange(numValue);
                }
            }
            else {
                _this.current(e.target.value);
            }
        };
        _this._finish = function () {
            var str = _this.state.stringValue;
            var number = _this._parse(str);
            // if number is below the min
            // we need to flush low values and decimal stops, onBlur means i'm done inputing
            if (_this.isIntermediateValue(number, str)) {
                if (isNaN(number)) {
                    number = undefined;
                }
                _this.props.onChange(number);
            }
        };
        _this._parse = function (strVal) {
            var culture = _this.props.culture;
            var delimChar = localizers_1.number.decimalChar(null, culture);
            var userParse = _this.props.parse;
            if (userParse) {
                return userParse(strVal, culture);
            }
            strVal = strVal.replace(delimChar, '.');
            return parseFloat(strVal);
        };
        _this.isIntermediateValue = function (num, str) {
            return !!(num < _this.props.min || _this.isSign(str) || _this.isAtDelimiter(num, str) || _this.isPaddedZeros(str));
        };
        _this.isSign = function (val) {
            return (val || '').trim() === '-';
        };
        _this.isPaddedZeros = function (str) {
            var localeChar = localizers_1.number.decimalChar(null, _this.props.culture);
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            var _a = str.split(localeChar), _ = _a[0], decimals = _a[1];
            return !!(decimals && decimals.match(/0+$/));
        };
        _this.isAtDelimiter = function (num, str, props) {
            if (props === void 0) { props = _this.props; }
            var localeChar = localizers_1.number.decimalChar(null, props.culture);
            var lastIndex = str.length - 1;
            if (str.length < 1) {
                return false;
            }
            var char = str[lastIndex];
            return !!(char === localeChar &&
                str.indexOf(char) === lastIndex);
        };
        _this.isValid = function (num) {
            if (typeof num !== 'number' || isNaN(num)) {
                return false;
            }
            return num >= _this.props.min;
        };
        //this intermediate state is for when one runs into the decimal or are typing the number
        _this.current = function (stringValue) {
            _this.setState({ stringValue: stringValue });
        };
        _this.state = _this.getDefaultState();
        return _this;
    }
    NumberInput.prototype.componentWillReceiveProps = function (nextProps) {
        this.setState(this.getDefaultState(nextProps));
    };
    NumberInput.prototype.render = function () {
        var value = this.state.stringValue;
        var customProps = _1.omit(this.props, Object.keys(NumberInput.propTypes));
        return (React.createElement("input", __assign({}, customProps, { className: this.props.className, type: "text", onChange: this._change, onBlur: this._finish, "aria-disabled": this.props.disabled, "aria-readonly": this.props.readOnly, disabled: this.props.disabled, readOnly: this.props.readOnly, placeholder: this.props.placeholder, value: value, onKeyPress: this.props.onKeyPress, onKeyUp: this.props.onKeyUp, autoFocus: this.props.autoFocus, name: this.props.name, role: this.props.role, tabIndex: this.props.tabIndex })));
    };
    NumberInput.propTypes = {
        value: PropTypes.number,
        placeholder: PropTypes.string,
        format: PropTypes.any,
        parse: PropTypes.func,
        culture: PropTypes.string,
        min: PropTypes.number,
        onChange: PropTypes.func.isRequired,
        onKeyDown: PropTypes.func,
        onKeyPress: PropTypes.func,
        onKeyUp: PropTypes.func,
        disabled: PropTypes.bool,
        readOnly: PropTypes.bool,
        editing: PropTypes.bool,
        className: PropTypes.string,
        autoFocus: PropTypes.bool,
        name: PropTypes.string,
        role: PropTypes.string,
        tabIndex: PropTypes.number
    };
    NumberInput.defaultProps = {
        min: 0,
        editing: false,
        onChange: function () { }
    };
    return NumberInput;
}(React.Component));
exports.NumberInput = NumberInput;
